import { jsx as _jsx } from "react/jsx-runtime";
import { CategoryIconContainer } from "./styled";
import { trimSlashes } from "../../utils";
export const CategoryIcon = ({ path, style, size }) => {
    if (!path) {
        return null;
    }
    return (_jsx(CategoryIconContainer, { style: style, size: size, children: _jsx("img", { src: `${trimSlashes(process.env.API_URL ?? "")}${path}`, width: "100%", alt: "" }) }));
};
